module.exports = __webpack_public_path__ + "static/img/home-hero-tablet-bg-03.35c6aa8.png";